import React, { useState, useContext, useEffect } from 'react';
import { NumericFormat } from 'react-number-format';
import { ShopperContext } from '../context/shopper';
import * as Constants from '../constants';
import { ErrorList } from './ErrorList';
import Checkbox from './Checkbox';
import { TermsPrivacyUrls } from './pieces/TermsPrivacyUrls';
import { useForm } from "../hooks/useForm";
import { useStyles } from "../hooks/useStyles";
import { usePhrasing, useLookups } from "../hooks/useSkuUtils";
import Table from 'react-bootstrap/Table';
import { useParams, useNavigate } from 'react-router-dom';
import { BackButton } from './BackButton';
import { HeadingBuilder } from './HeadingBuilder';
import { SelectOption } from "./SelectOption";
import { useTranslation } from "react-i18next";
//import styled from 'styled-components';
import styles from '../css/trTdFirstChild.module.css';

export const ShopperEditForm = () => {
    const { signedIn, shopper, circleShoppers,
      fetchShopper, editShopper,
      errorsDoExist, dismissErrorsList, setErrorsDoExistToFalse,
      setJustGotClearToFalse } = useContext(ShopperContext);
    console.log('sef shopper: ', shopper)
    console.log('sef circleShoppers: ', circleShoppers)

    const { tableShow, tableData, veryLightBlueBg } = useStyles();
    const {
      getShowTippyHelpIconLabel,
      getShowTooltipsTippy,
      getShowTooltipsTippyAudio,
      getShowVideoTipsTippy,
      getShowVideoTipsTippyAudio,
      getShopperShortnameTippyText,
      getShopperShortnameTippyAudio,
    } = usePhrasing();

    const { voice_option_groups } = useLookups();

    const {id} = useParams();
    console.log('sef id: ', id)

    const navigate = useNavigate();

    const refreshShopper = (e) => {
      e.preventDefault();
      async function getShopper() {
        try {
          await fetchShopper();
          navigate(`/shoppers/${shopper.id}`)
        } catch (error) {
          console.error(error);
        }
      }
      getShopper();
    }

    useEffect(() => {
      dismissErrorsList();
    }, [dismissErrorsList]);

    const [showChangeEmail, setShowChangeEmail] = useState(false);
    const toggleSetShowChangeEmail = (e) => {
      e.preventDefault();
      setShowChangeEmail( () => !showChangeEmail )
    }

    const [ttsRowsFlag, setTtsRowsFlag] = useState(false);
    const showTheTtsRows = () => { setTtsRowsFlag(true)  }
    const hideTheTtsRows = () => { setTtsRowsFlag(false) }

    const shopperObj =
      shopper.id == id
        ? {shopper: shopper}
        : circleShoppers.find(cs =>  cs.shopper_id == id);
    console.log('sef shopperObj: ', shopperObj)

    if (shopperObj == null) {
      console.log('cef shopperObj2: ', shopperObj)
      // User likely used browser to refresh the page, lost access to state.
      // This causes 'shopperObj' to be 'undefined'.
      // Let's go back to the 'home' page, '/'.
      window.location.replace('/');
      // Not to '/shoppers/' because we don't use that to show shoppers.
      // This doesn't work either: window.location.replace(`/shoppers/${id}`);

      // Error messages still fly from using 'shopperObj', but at least this
      // lands somewhere nice.
    }

    const { t } = useTranslation();

    const initialState = {...shopperObj.shopper,
      show_tippy_help_alert_icons:
                       shopperObj.shopper.show_tippy_help_alert_icons ? 1 : 0,
      show_help_video_icons: shopperObj.shopper.show_help_video_icons ? 1 : 0,
      agree_tos_pp_a: shopperObj.shopper.agree_tos_pp_a,
      mktg_email_optin: shopperObj.shopper.mktg_email_optin ? 1 : 0,
      unconfirmed_email_confirmation: shopperObj.shopper.unconfirmed_email,
      help_voice: shopperObj.shopper.help_voice
                    ? shopperObj.shopper.help_voice
                    : Constants.TIPPY_HELP_VOICE,
      tts_rate: shopperObj.shopper.tts_rate
                    ? shopperObj.shopper.tts_rate
                    : Constants.TIPPY_TTS_RATE,
    };
    console.log("sef initialStateA", initialState);

    // avoid warnings like:
    // react_devtools_backend.js:4012 Warning: `value` prop on `input` should
    // not be null. Consider using an empty string to clear the component or
    // `undefined` for uncontrolled components.
    const shopperStringCols = [
      "identifier",
      "firstname",
      "lastname",
      "shortname",
      "email",
      "unconfirmed_email",
      "unconfirmed_email_confirmation",
      // "image_url",
      // "bio",
      // "postal_code",
      "show_tippy_help_alert_icons",
      "show_help_video_icons",
      // "agree_tos_pp_a",
      "password",
      "password_confirmation",
      // "password_digest"
      "mktg_email_optin",
      "help_voice",
      "tts_rate",
    ];
      // TODO: Why is this here? "password_digest"
      // And have just added 'password' and 'password_confirmation'. Ok?

    for (const item of shopperStringCols) {
      if (initialState[item] == null) {
        initialState[item] = '';
      }
    }
    console.log("sef initialStateB", initialState);

    // Keep this in reserve for if we see more errors regarding
    // forms whose attributes are null.
    // Per https://stackoverflow.com/a/73514331 :
    // We could convert any null attr values of shopperObj to ''.
    // We get away with the below since all shopper attrs are strings.
    // const xinitialState = JSON.parse(
    //   JSON.stringify(shopperObj.shopper), (key, value) => {
    //     return value || '';
    //   }
    // );
    // console.log("sef xinitialState", xinitialState);

    const { formData, handleChange, reset, editFormValues } = useForm(initialState);

    const showTippyHelpIconLabel     = getShowTippyHelpIconLabel();

    const showTooltipsTippy          = getShowTooltipsTippy();
    const showTooltipsTippyAudio     = getShowTooltipsTippyAudio();

    const showVideoTipsTippy         = getShowVideoTipsTippy();
    const showVideoTipsTippyAudio    = getShowVideoTipsTippyAudio();

    const shopperShortnameTippyText  = getShopperShortnameTippyText();
    const shopperShortnameTippyAudio = getShopperShortnameTippyAudio();

    const voiceOptions = voice_option_groups().map(
      group =>
        <optgroup key={group.tag} label={group.label}>
          {/* Deutsch */}
          {group.voices.map(
            aVoice =>
              <SelectOption
                key      = {aVoice.slug}
                optValue = {aVoice.slug}
                // google_de_de_female
                optLabel = {aVoice.label}
                // Deutschland · Google
              />
          )}
        </optgroup>
    );

    const noDeleteYourAcctLabel =
        t('global.label.no')
      + ' - '
      + t('shopper.deleteAccountButton.label');
      // No - Delete My Account

    const disagreeAndDeleteYourAcctMsg =
        t('shopper.disagreeTermsPrivacy.tippyContent')
      + ' '
      + t('shopper.deleteAccountButton.tippyContent');
      // You don't agree with the 'Terms of Service' and 'Privacy Policy'. Click this button to open a form that lets you delete your account and its data.

    const tippyForButtonToChangeEmailAddr =
        t('shopper.email.editShopperTippyContent')
      + ' // '
      + t('shopper.email.noteAboutChangeEmail');
      // ShopWeAll and other circle shoppers can reach you at this email address.
      // Click here to change your email address.

    if (signedIn) {
        const handleSubmit = (e) => {
            e.preventDefault();
        
            // clear out any error messages, success statuses
            dismissErrorsList();
            setErrorsDoExistToFalse();
            setJustGotClearToFalse();
        
            console.log('formData for editPrice: ', formData);
            editShopper(formData);
        
            // If there is an error we want to preserve formData and show the message.
        }

        return (
          <article>
            <HeadingBuilder
              Size        = 'h3'
              headingText = {t('shopper.formPart.headlineUpdateProfile')}
              value       = {shopper.identifier}
              // Update Shopper Profile for: uiui
            />
              <form onSubmit={handleSubmit}>
<Table responsive striped bordered hover size="sm" style={tableShow}>
  <thead >
  </thead>
  <tbody className={styles.trTdFC} style={tableData} >
    <tr>
      <td>
        <HeadingBuilder
          containerType  = 'container-input-label'
          headingText    = {t('shopper.firstname.label')}
            // First Name:
          labelHtmlFor   = "firstname_sef"
          tippyAlertText = {t('shopper.firstname.tippyContent')}
          tippyText      = {t('shopper.firstname.tippyContent')}
        />
      </td>
      <td>
        <input
          key="10"
          type="text"
          id="firstname_sef"
          name="firstname"
          autoComplete="given-name"
          maxLength={Constants.NAME_MAX_LENGTH}  // 40
          onChange={handleChange}
          value={formData.firstname}
          required
        />
        &nbsp;*
      </td>
    </tr>
    <tr>
      <td>
        <HeadingBuilder
          containerType  = 'container-input-label'
          headingText    = {t('shopper.lastname.label')}
            // Last Name:
          labelHtmlFor   = "lastname_sef"
          tippyAlertText = {t('shopper.lastname.tippyContent')}
          tippyText      = {t('shopper.lastname.tippyContent')}
        />
      </td>
      <td>
        <input
          key="20"
          type="text"
          id="lastname_sef"
          name="lastname"
          autoComplete="family-name"
          maxLength={Constants.NAME_MAX_LENGTH}  // 40
          onChange={handleChange}
          value={formData.lastname}
        />
      </td>
    </tr>
    <tr>
      <td>
        <HeadingBuilder
          containerType  = 'container-input-label'
          headingText    = {t('shopper.shortname.label')}
            // Shortname:
          labelHtmlFor   = "shortname_sef"
          tippyAlertText = {shopperShortnameTippyText}
          tippyText      = {shopperShortnameTippyText}
          tippyAlertAudio= {shopperShortnameTippyAudio}
        />
      </td>
      <td>
        <input
          key="35"
          type="text"
          id="shortname_sef"
          name="shortname"
          autoComplete="username"
          onChange={handleChange}
          value={formData.shortname}
          required
        />
        &nbsp;*
      </td>
    </tr>
    <tr>
      <td>
      { (formData.unconfirmed_email != undefined  &&
         formData.unconfirmed_email.length > 0)
      ? <HeadingBuilder
          containerType  = 'container-input-label'
          headingText    = {t('shopper.email.label')}
            // Email:
          labelHtmlFor   = "email_sef"
          tippyAlertText = {t('shopper.email.editShopperTippyContent')}
          tippyText      = {t('shopper.email.editShopperTippyContent')}
        />
      : <HeadingBuilder
          containerType  = 'container-input-label'
          headingText    = {t('shopper.email.label')}
            // Email:
          labelHtmlFor   = "email_sef"
          buttonAction   = {toggleSetShowChangeEmail}
          goButtonText   = {Constants.GET_ICON_CHANGE}
          tippyAlertText = {tippyForButtonToChangeEmailAddr}
          tippyText      = {tippyForButtonToChangeEmailAddr}
        />
      }
      </td>
      <td>
        {/* {formData.email} */}
        { // it will be unusual for 'shopper.unconfirmed_email' to exist,
          // so it will be rare that we show the 'refresh' button for email
          (shopper.unconfirmed_email != undefined  &&
            shopper.unconfirmed_email.length > 0)
            ? <HeadingBuilder
                containerType  = 'container-input-label-left'
                headingText    = {formData.email}
                buttonAction   = {refreshShopper}
                goButtonText   = {Constants.GET_ICON_REFRESH}
                tippyAlertText = {t('shopper.email.noteAboutRefreshEdit')}
                tippyText      = {t('shopper.email.noteAboutRefreshEdit')}
              />
            : formData.email
              // seems to do 'justify-content: left' naturally
        }
      </td>
    </tr>
    { showChangeEmail ||  // or if 'unconfirmed_email' has a value, i.e.
       (shopper.unconfirmed_email != undefined  &&
        shopper.unconfirmed_email.length > 0)
    ? <>
      <tr>
      <td>
        <HeadingBuilder
          containerType  = 'container-input-label'
          headingText    = {t('shopper.unconfirmedEmail.label')}
            // New Email:
          labelHtmlFor   = "unconfirmed_email_sef"
          tippyAlertText = {t('shopper.unconfirmedEmail.tippyContent')}
          tippyText      = {t('shopper.unconfirmedEmail.tippyContent')}
          tippyInfoText  = {t('shopper.unconfirmedEmail.tippyInfoContent')}
        />
      </td>
      <td
        style={{
          background:  formData.unconfirmed_email.length === 0 ? "lightblue" : "none"
        }} 
      >
        <input
          key="40"
          type="text"
          style={{ textTransform: "lowercase" }}
          id="unconfirmed_email_sef"
          name="unconfirmed_email"
          autoComplete="email"
          maxLength={Constants.EMAIL_MAX_LENGTH}  // 60
          onChange={handleChange}
          value={formData.unconfirmed_email}
        />
      </td>
      </tr>
      <tr>
      <td>
        <HeadingBuilder
          containerType  = 'container-input-label'
          headingText    = {t('shopper.unconfirmedEmailConfirmation.label')}
            // New Email (repeated):
        tippyAlertText = {t('shopper.unconfirmedEmailConfirmation.tippyContent')}
        tippyText      = {t('shopper.unconfirmedEmailConfirmation.tippyContent')}
          labelHtmlFor   = "unconfirmed_email_confirmation_sef"
        />
      </td>
      <td
        style={{
          background:
    formData.unconfirmed_email_confirmation.length === 0 ? "lightblue" : "none"
        }} 
      >
        <input
          key="45"
          type="text"
          style={{ textTransform: "lowercase" }}
          id="unconfirmed_email_confirmation_sef"
          name="unconfirmed_email_confirmation"
          autoComplete="email"
          disabled={
            formData.unconfirmed_email.trim().length === 0
          }
          maxLength={Constants.EMAIL_MAX_LENGTH}  // 60
          onChange={handleChange}
          value={formData.unconfirmed_email_confirmation}
          // Using 'disabled' and not 'required' since the shopper might change
          // their mind and want blank. 'required' would force an entry anyway.
        />
      </td>
      </tr>
      </>
    : null
    }
    <tr>
      <td>
        <HeadingBuilder
          containerType  = 'container-input-label'
          headingText    = {t('shopper.password.label')}
            // Password:
          labelHtmlFor   = "password_sef"
          tippyAlertText = {t('shopper.password.tippyContent')}
          tippyText      = {t('shopper.password.tippyContent')}
        />
      </td>
      <td>
        <input
          key="50"
          type="password"
          id="password_sef"
          name="password"
          autoComplete="new-password"
          onChange={handleChange}
          value={formData.password}
        />
      </td>
    </tr>
    <tr>
      <td>
        <HeadingBuilder
          containerType  = 'container-input-label'
          headingText    = {t('shopper.password_confirmation.label')}
            // Password Confirmation:
          labelHtmlFor   = "password_confirmation_sef"
          tippyAlertText = {t('shopper.password_confirmation.tippyContent')}
          tippyText      = {t('shopper.password_confirmation.tippyContent')}
        />
      </td>
      <td>
        <input
          key="60"
          type="password"
          id="password_confirmation_sef"
          name="password_confirmation"
          autoComplete="current-password"
          onChange={handleChange}
          value={formData.password_confirmation}
        />
      </td>
    </tr>
  { false
    ?
    <tr>
      <td>
        <HeadingBuilder
          containerType  = 'container-input-label'
          headingText    = {t('shopper.postal_code.label')}
            // Zip/Postal Code:
          labelHtmlFor   = "postal_code_sef"
          tippyAlertText = {t('shopper.postal_code.tippyContent')}
          tippyText      = {t('shopper.postal_code.tippyContent')}
        />
      </td>
      <td>
        <input
          key="80"
          type="text"
          id="postal_code_sef"
          name="postal_code"
          autoComplete="postal-code"
          onChange={handleChange}
          value={formData.postal_code}
        />
      </td>
    </tr>
    : null
  }
    <tr>
      <td>
        {/* Settings: */}
        <em>{t('shopper.settings.label')}</em>
      </td>
      <td>
        {null}
      </td>
    </tr>
    <tr>
      <td>
        <HeadingBuilder
          containerType  = 'container-input-label'
          headingText    = {showTippyHelpIconLabel}
            // Show tooltips via [?] button
          labelHtmlFor   = "show_tippy_help_alert_icons"
          tippyAlertText = {showTooltipsTippy}
          tippyText      = {showTooltipsTippy}
          tippyAlertAudio= {showTooltipsTippyAudio}
          // ShopWeAll uses tooltips to provide ...
        />
      </td>
      <td>
        <select
          key="100"
          type="text"
          id="show_tippy_help_alert_icons"
          name="show_tippy_help_alert_icons"
          onChange={handleChange}
          value={formData.show_tippy_help_alert_icons}
        >
          {/* <option value="0">No</option> */}
          <option value="0">{t('shopper.showTippyHelpIcon.optionValue0')}</option>
          {/* <option value="1">Yes</option> */}
          <option value="1">{t('shopper.showTippyHelpIcon.optionValue1')}</option>
        </select>
      </td>
    </tr>
    <tr>
      <td>
        <HeadingBuilder
          containerType  = 'container-input-label'
          headingText    = {t('shopper.showVideoTipsIcon.label')}
            // Show video tips
          labelHtmlFor   = "show_help_video_icons"
          tippyAlertText = {showVideoTipsTippy}
          tippyText      = {showVideoTipsTippy}
          tippyAlertAudio= {showVideoTipsTippyAudio}
          // ShopWeAll often displays a 'Show video tips' icon...
        />
      </td>
      <td>
        <select
          key="110"
          type="text"
          id="show_help_video_icons"
          name="show_help_video_icons"
          onChange={handleChange}
          value={formData.show_help_video_icons}
        >
          {/* <option value="0">No</option> */}
          <option value="0">{t('shopper.showVideoTipsIcon.optionValue0')}</option>
          {/* <option value="1">Yes</option> */}
          <option value="1">{t('shopper.showVideoTipsIcon.optionValue1')}</option>
        </select>
      </td>
    </tr>
    <tr>
      <td>
        <HeadingBuilder
          containerType  = 'container-input-label'
          headingText    = {t('tts.shopper.label')}
          // Help Text Voiceovers
          tippyAlertText = {t('tts.shopper.setupTtsCtlButtonTippyContent')}
          tippyText      = {Constants.DOT}
// You can control the voice and playback rate of help tips via these settings.
        />
      </td>
      <td>
        <>
        {ttsRowsFlag
          ? <HeadingBuilder
              containerType  = 'container-left'
              headingText    = {t('tts.shopper.ttsCtlButtonText', {
                           actionDataType: t('tts.shopper.dataTypeTextHideEdit')
                                })}
              // STOP showing controls for help text playback
              buttonAction   = {hideTheTtsRows}
              goButtonText   = {Constants.GET_ICON_RT_ARROW}
              bgroundColor   = {Constants.LIGHT_BLUE}
              tippyText      = {Constants.DOT}
            />
          : <HeadingBuilder
              containerType  = 'container-left'
              headingText    = {t('tts.shopper.ttsCtlButtonText', {
                           actionDataType: t('tts.shopper.dataTypeTextShowEdit')
                               })}
              // Show controls for help text playback
              buttonAction   = {showTheTtsRows}
              goButtonText   = {Constants.GET_ICON_RT_ARROW}
              tippyText      = {Constants.DOT}
            />
        }
        </>
      </td>
    </tr>
    { ttsRowsFlag
    ? <>
    <tr>
      <td>
        <HeadingBuilder
          containerType  = 'container-input-label'
          headingText    = {t('tts.shopper.editProfileLabel')}
          // Choose a Help Voice
          labelHtmlFor   = "help_voice_sef"
          tippyAlertText = {t('tts.shopper.tippyContent',
                                    {preamble: t('tts.shopper.editProfile')} )}
          tippyText      = {Constants.DOT}
          // What voice should read help tips for you? ...
        />
      </td>
      <td style={veryLightBlueBg}>
        <select
          key="115"
          type="text"
          id="help_voice_sef"
          name="help_voice"
          onChange={handleChange}
          value={formData.help_voice}
        >
          {/* <option value="">Choose one:/option> */}
          <option value='' disabled>{t('global.chooseOne')}</option>

          {voiceOptions}
        </select>
      </td>
    </tr>
    <tr>
      <td>
        <HeadingBuilder
          containerType  = 'container-input-label'
          headingText    = {t('tts.shopper.ttsRateLabel')}
          // Help Playback Speed
          labelHtmlFor   = "tts_rate_sef"
          tippyAlertText = {t('tts.shopper.ttsRateTippyContent', {
            preamble: "",
            postscript: t('tts.shopper.ttsRatePostscript')
          })}
          // A value of '1.0' represents the standard playback rate for help tips. A lower value, like '0.8' will cause playback to slow down. A higher value, like  '1.2' or '1.4', will speed it up.
          tippyText      = {Constants.DOT}
        />
      </td>
      <td style={veryLightBlueBg}>
        <NumericFormat displayType="input"
          key="118"
          type="text"
          id="tts_rate_sef"
          name="tts_rate"
          onChange={handleChange}
          value={formData.tts_rate}
          decimalScale={1}
        />
      </td>
    </tr>
      </>
    : null
    }
    <tr>
      <td>
        <HeadingBuilder
          containerType='container-input-label'
          headingText = {
              t('shopper.mktgEmailOptin.label') 
            + ' - '
            + t('shopper.mktgEmailOptin.description')
          }
// Email Opt-in - Send me helpful advice, news, and exclusive offers (Optional).
          labelHtmlFor   = "mktg_email_optin_edit"
          tippyAlertText = {t('shopper.mktgEmailOptin.tippyContent', {
                              takeAction: t('shopper.mktgEmailOptin.clickYes')
                           })}
          tippyText      = {Constants.DOT}
// Because we respect your inbox, we only send account-specific alerts by default. If you would like to receive newsletter updates, usage advice, and exclusive offers, click 'Yes' to opt-in.  
        />
      </td>
      <td>
        <select
          key="119"
          type="text"
          id="mktg_email_optin_edit"
          name="mktg_email_optin"
          onChange={handleChange}
          value={formData.mktg_email_optin}
        >
          {/* <option value="0">No</option> */}
          <option value="0">{t('global.label.no')}</option>
          {/* <option value="1">Yes</option> */}
          <option value="1">{t('global.label.yes')}</option>
        </select>
      </td>
    </tr>
    <tr>
      <td>
        <HeadingBuilder
          containerType  = 'container-input-label'
          headingText    = {t('shopper.agreeTermsPrivacyA.label')}
          // I have read and agree to...
          labelHtmlFor   = "agree_tos_pp_a_sef"
          tippyAlertText = {t('shopper.agreeTermsPrivacyA.legallyBinding')}
          tippyText      = {t('shopper.agreeTermsPrivacyA.legallyBinding')}
          // These are legally binding agreements for ...
          tippyInfoText = {t('shopper.agreeTermsPrivacyA.termsPrivacy')}
          // 'Terms' is the agreement between you and ...
        />
      </td>
      <td>
        <TermsPrivacyUrls />
        <div>
          <Checkbox
            size         = "swa-generic"
            key          = "130"
            isChecked    = {true}
            label        = {t('global.label.yes')}
            // Yes
            tippyAlert   = {t('shopper.agreeTermsPrivacyA.tippyContent')}
            // Click the checkbox to show your agreement with...
            // Note: Clicking the checkbox does nothing. Shopper must click
            // the 'No - Delete My Account' button if they don't want 'Yes'.
          />
        </div>
        <HeadingBuilder
          headingText    = {noDeleteYourAcctLabel}
          // No - Delete My Account
          linkUrl        = {`/shoppers/${shopper.id}/delete`}
          tippyText      = {Constants.DOT}
          tippyInfoText  = {disagreeAndDeleteYourAcctMsg}
// If you don't agree with the 'Terms of Service' and 'Privacy Policy': Click...
        />
      </td>
    </tr>
  </tbody>
</Table>
          <input key="200" type='submit' value='Submit' />
        </form>
        { errorsDoExist && <ErrorList /> }
        <BackButton />
        {/* <BackButton whatToDo={resetSkuTypeFormFlags}/> */}
      </article>
     )
    } else {
      return (
        <HeadingBuilder
          Size = 'h3'
          headingText = {t('global.notSignedInMessage')}
          // Not Authorized - Please Sign in or Sign up
        />
      )
    }
}

export default ShopperEditForm;